import { createContext, useContext, ReactNode } from 'react';
import { isRightToLeft, getRtlDirection } from '@/utils/rtl';

interface RTLContextType {
  inputRTL: boolean;
  outputRTL: boolean;
  inputDirection: 'ltr' | 'rtl';
  outputDirection: 'ltr' | 'rtl';
  // Helper methods for common CSS classes
  inputTextAlign: string;
  outputTextAlign: string;
}

const RTLContext = createContext<RTLContextType>({
  inputRTL: false,
  outputRTL: false,
  inputDirection: 'ltr',
  outputDirection: 'ltr',
  inputTextAlign: 'text-left',
  outputTextAlign: 'text-left'
});

interface RTLProviderProps {
  children: ReactNode;
  inputLanguageId?: string;
  outputLanguageId?: string;
}

export function RTLProvider({ children, inputLanguageId, outputLanguageId }: RTLProviderProps) {
  const inputRTL = inputLanguageId ? isRightToLeft(inputLanguageId) : false;
  const outputRTL = outputLanguageId ? isRightToLeft(outputLanguageId) : false;
  const inputDirection = inputLanguageId ? getRtlDirection(inputLanguageId) : 'ltr';
  const outputDirection = outputLanguageId ? getRtlDirection(outputLanguageId) : 'ltr';

  return (
    <RTLContext.Provider value={{
      inputRTL,
      outputRTL,
      inputDirection,
      outputDirection,
      inputTextAlign: inputRTL ? 'text-right' : 'text-left',
      outputTextAlign: outputRTL ? 'text-right' : 'text-left'
    }}>
      {children}
    </RTLContext.Provider>
  );
}

export function useTranslationRTL() {
  return useContext(RTLContext);
}
